import React from 'react';
import { useLang } from '../context/LanguageContext';

export default function Footer({ onNavigate }) {
  const { t } = useLang();
  const f = t.footer;

  return (
    <footer className="bg-slate-900 text-slate-400 text-sm">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">

          {/* ── Brand ── */}
          <div className="col-span-2 md:col-span-1">
            <button onClick={() => onNavigate('home')} className="flex items-center gap-2 mb-3 group">
              <div className="w-7 h-7 bg-primary-600 rounded-lg flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <span className="text-white text-xs font-black">H</span>
              </div>
              <span className="text-white font-black text-base">Hay<span className="text-primary-400">Taxi</span></span>
            </button>
            <p className="text-slate-500 text-xs leading-relaxed">{f.tagline}</p>
          </div>

          {/* ── Company ── */}
          <div>
            <h3 className="text-white font-semibold text-xs uppercase tracking-wider mb-3">{f.company}</h3>
            <ul className="space-y-2">
              <li><button onClick={() => onNavigate('about')} className="hover:text-white transition-colors">{f.about}</button></li>
              <li><button onClick={() => onNavigate('help')}  className="hover:text-white transition-colors">{f.help}</button></li>
            </ul>
          </div>

          {/* ── Riders ── */}
          <div>
            <h3 className="text-white font-semibold text-xs uppercase tracking-wider mb-3">{f.ridersCol}</h3>
            <ul className="space-y-2">
              <li><button onClick={() => onNavigate('book')}   className="hover:text-white transition-colors">{f.bookRide}</button></li>
              <li><button onClick={() => onNavigate('riders')} className="hover:text-white transition-colors">{f.howItWorks}</button></li>
            </ul>
          </div>

          {/* ── Drivers ── */}
          <div>
            <h3 className="text-white font-semibold text-xs uppercase tracking-wider mb-3">{f.driversCol}</h3>
            <ul className="space-y-2">
              <li><button onClick={() => onNavigate('auth')}    className="hover:text-white transition-colors">{f.becomeDriver}</button></li>
              <li><button onClick={() => onNavigate('drivers')} className="hover:text-white transition-colors">{f.howItWorks}</button></li>
            </ul>
          </div>

        </div>

        {/* ── Bottom bar ── */}
        <div className="border-t border-slate-800 pt-6 text-center text-xs text-slate-600">
          {f.copy}
        </div>
      </div>
    </footer>
  );
}
